export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12051.deb346c8.jpg";